export default "__VITE_PUBLIC_ASSET__acce48c8__"